import { CellType } from "@nf/common";

import type { Breakpoint, GridBreakpoint, GridResponsiveConfig } from "./types";

export const DEFAULT_COLS_BY_TYPE: Partial<
  Record<CellType, Record<Breakpoint, number>>
> = {
  [CellType.Cover]: { phone: 3, tablet: 3, desktop: 4, large: 6 },
  [CellType.CoverLarge]: { phone: 3, tablet: 3, desktop: 4, large: 6 },
  [CellType.Circle]: { phone: 2, tablet: 3, desktop: 4, large: 6 },
  [CellType.Default]: { phone: 2, tablet: 2, desktop: 3, large: 3 },
};

export const DEFAULT_GAPS_BY_TYPE: Partial<
  Record<CellType, Record<Breakpoint, string>>
> = {
  [CellType.Circle]: {
    phone: "24px",
    tablet: "24px",
    desktop: "24px",
    large: "32px",
  },
  [CellType.Default]: {
    phone: "8px",
    tablet: "8px",
    desktop: "16px",
    large: "16px",
  },
};

export const resolveResponsiveProp = (
  responsive: GridResponsiveConfig | undefined,
  prop: keyof GridBreakpoint,
  defaults: Record<Breakpoint, string | number>
): Record<Breakpoint, string | number> => {
  const phone = responsive?.phone?.[prop] ?? defaults.phone;

  const tablet =
    responsive?.tablet?.[prop] ?? responsive?.phone?.[prop] ?? defaults.tablet;

  const desktop =
    responsive?.desktop?.[prop] ??
    responsive?.tablet?.[prop] ??
    responsive?.phone?.[prop] ??
    defaults.desktop;

  const large =
    responsive?.large?.[prop] ??
    responsive?.desktop?.[prop] ??
    responsive?.tablet?.[prop] ??
    responsive?.phone?.[prop] ??
    defaults.large;

  return { phone, tablet, desktop, large };
};

export const getDefaultForCellType = <T>(
  map: Partial<Record<CellType, T>>,
  cellType?: CellType
): T => {
  if (cellType) {
    return map[cellType] ?? map[CellType.Default]!;
  }

  return map[CellType.Default]!;
};
